<template>
  <div class="how-to-measure">
    <h2
      class="how-to-measure__title text-body-2xs-regular"
      v-text="$string('product.size_guide.how_to_measure_title')"
    />

    <p
      class="how-to-measure__subtitle"
      v-text="$string('product.size_guide.how_to_measure_subtitle')"
    />

    <div class="how-to-measure__chart-wrapper">
      <responsive-image
        v-if="image"
        :image="image"
        :ratio="false"
        class="how-to-measure__image"
      />

      <div
        v-if="copy"
        class="how-to-measure__copy text-body-2xs-regular rte"
        v-html="copy"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: How to measure (how-to-measure)
 * -----------------------------------------------------------------------------
 * How to Measure chart used on size guide drawer and pages.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'HowToMeasure',

  components: {
    ResponsiveImage,
  },

  props: {
    copy: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss">
@import './how-to-measure';
</style>
